module.exports = __webpack_public_path__ + "img/Upstairs_2_thumbnail.67699399.webp";